
      /* <AUTO-GENERATED-SCRIPTS> */
  // Event emitted when an accordion item is closed.
        document.querySelector('#ifx-accordion-example ifx-accordion')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

        // Event emitted when accordion is opened.
        document.querySelector('#ifx-accordion-example ifx-accordion')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

            // Event emitted when the main item area is clicked
        document.querySelector('#ifx-action-list-example ifx-action-list')?.addEventListener('ifxActionListItemClick', (event) => {
          console.log('ifxActionListItemClick:', event);
          // Add your custom handler logic here
        });

        // Emitted when the provided icon name is invalid and the component fails to render an icon.
        // The event detail contains a boolean value `true` indicating an error occurred.
        document.querySelector('#ifx-action-list-example ifx-action-list')?.addEventListener('consoleError', (event) => {
          console.log('consoleError:', event);
          // Add your custom handler logic here
        });

            // Event emitted when the component is closed.
        document.querySelector('#ifx-alert-example ifx-alert')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

            // Emits the image position when it changes or is set.
        document.querySelector('#ifx-card-example ifx-card')?.addEventListener('imgPosition', (event) => {
          console.log('imgPosition:', event);
          // Add your custom handler logic here
        });

            // Event emitted when the checkbox state changes.
        // Emits the new checked state as a boolean value.
        document.querySelector('#ifx-checkbox-example ifx-checkbox')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Event emitted when the error state changes.
        // Emits the new error state as a boolean value.
        document.querySelector('#ifx-checkbox-example ifx-checkbox')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

            // Event emitted when the checkbox state changes.
        // Emits the new checked state as a boolean value.
        document.querySelector('#ifx-checkbox-group-example ifx-checkbox-group')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Event emitted when the error state changes.
        // Emits the new error state as a boolean value.
        document.querySelector('#ifx-checkbox-group-example ifx-checkbox-group')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

            // Fires on selection change.
        document.querySelector('#ifx-chip-example ifx-chip')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Emitted on chip select/deselect.
        document.querySelector('#ifx-chip-example ifx-chip')?.addEventListener('ifxChipItemSelect', (event) => {
          console.log('ifxChipItemSelect:', event);
          // Add your custom handler logic here
        });

            // Fired when the selected option changes.
        document.querySelector('#ifx-content-switcher-example ifx-content-switcher')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Emitted when the provided icon name is invalid and the component fails to render an icon.
        // The event detail contains a boolean value `true` indicating an error occurred.
        document.querySelector('#ifx-content-switcher-example ifx-content-switcher')?.addEventListener('consoleError', (event) => {
          console.log('consoleError:', event);
          // Add your custom handler logic here
        });

            // Event emitted when date value changes
        document.querySelector('#ifx-date-picker-example ifx-date-picker')?.addEventListener('ifxDate', (event) => {
          console.log('ifxDate:', event);
          // Add your custom handler logic here
        });

            // Fired when dropdown closed.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

        // General dropdown event.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxDropdown', (event) => {
          console.log('ifxDropdown:', event);
          // Add your custom handler logic here
        });

        // Fired when dropdown open.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

        // Fired when a dropdown menu item is selected
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxDropdownMenuItem', (event) => {
          console.log('ifxDropdownMenuItem:', event);
          // Add your custom handler logic here
        });

        // Emits the calculated size of the menu
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('menuSize', (event) => {
          console.log('menuSize:', event);
          // Add your custom handler logic here
        });

        // Fired when the dropdown item is clicked or selected.
        document.querySelector('#ifx-dropdown-example ifx-dropdown')?.addEventListener('ifxDropdownItem', (event) => {
          console.log('ifxDropdownItem:', event);
          // Add your custom handler logic here
        });

            // Emitted when the provided icon name is invalid and the component fails to render an icon.
        // The event detail contains a boolean value `true` indicating an error occurred.
        document.querySelector('#ifx-footer-example ifx-footer')?.addEventListener('consoleError', (event) => {
          console.log('consoleError:', event);
          // Add your custom handler logic here
        });

            // Fired when the mobile navbar menu is opened or closed.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxNavbarMobileMenuIsOpen', (event) => {
          console.log('ifxNavbarMobileMenuIsOpen:', event);
          // Add your custom handler logic here
        });

        // Fired when the navigation item is activated or clicked.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxNavItem', (event) => {
          console.log('ifxNavItem:', event);
          // Add your custom handler logic here
        });

        // Emits when the search input value changes.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Emits when the search bar is opened or closed.
        // Payload is the new open state.
        document.querySelector('#ifx-navbar-example ifx-navbar')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

            // Emitted when collapsed state changes
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarCollapseChange', (event) => {
          console.log('ifxSidebarCollapseChange:', event);
          // Add your custom handler logic here
        });

        // Emitted when logo image is clicked
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarLogoClick', (event) => {
          console.log('ifxSidebarLogoClick:', event);
          // Add your custom handler logic here
        });

        // Event fired when an action item is clicked
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarActionItem', (event) => {
          console.log('ifxSidebarActionItem:', event);
          // Add your custom handler logic here
        });

        // Event fired for menu item interactions
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarMenu', (event) => {
          console.log('ifxSidebarMenu:', event);
          // Add your custom handler logic here
        });

        // Event fired when a navigation item is clicked
        document.querySelector('#ifx-sidebar-example ifx-sidebar')?.addEventListener('ifxSidebarNavigationItem', (event) => {
          console.log('ifxSidebarNavigationItem:', event);
          // Add your custom handler logic here
        });

            // Event emitted when the notification is closed.
        document.querySelector('#ifx-notification-example ifx-notification')?.addEventListener('ifxClose', (event) => {
          console.log('ifxClose:', event);
          // Add your custom handler logic here
        });

            // Emitted when the items-per-page value changes
        document.querySelector('#ifx-pagination-example ifx-pagination')?.addEventListener('ifxItemsPerPageChange', (event) => {
          console.log('ifxItemsPerPageChange:', event);
          // Add your custom handler logic here
        });

        // Emitted when the current page changes
        document.querySelector('#ifx-pagination-example ifx-pagination')?.addEventListener('ifxPageChange', (event) => {
          console.log('ifxPageChange:', event);
          // Add your custom handler logic here
        });

            // Fired when the checked state of the checkbox changes.
        document.querySelector('#ifx-radio-button-example ifx-radio-button')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Fired when the checkbox enters or leaves an error state.
        document.querySelector('#ifx-radio-button-example ifx-radio-button')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

            // Fired when the checked state of the checkbox changes.
        document.querySelector('#ifx-radio-button-group-example ifx-radio-button-group')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Fired when the checkbox enters or leaves an error state.
        document.querySelector('#ifx-radio-button-group-example ifx-radio-button-group')?.addEventListener('ifxError', (event) => {
          console.log('ifxError:', event);
          // Add your custom handler logic here
        });

            // Emits when the search input value changes.
        document.querySelector('#ifx-search-bar-example ifx-search-bar')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Emits when the search bar is opened or closed.
        // Payload is the new open state.
        document.querySelector('#ifx-search-bar-example ifx-search-bar')?.addEventListener('ifxOpen', (event) => {
          console.log('ifxOpen:', event);
          // Add your custom handler logic here
        });

            // Emitted when the input loses focus.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxBlur', (event) => {
          console.log('ifxBlur:', event);
          // Add your custom handler logic here
        });

        // Emitted when the input gains focus.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxFocus', (event) => {
          console.log('ifxFocus:', event);
          // Add your custom handler logic here
        });

        // Emitted on input change with the current value.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Emitted to request external suggestions for the given query.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxSuggestionRequested', (event) => {
          console.log('ifxSuggestionRequested:', event);
          // Add your custom handler logic here
        });

        // Emitted when a suggestion or history item is selected.
        document.querySelector('#ifx-search-field-example ifx-search-field')?.addEventListener('ifxSuggestionSelected', (event) => {
          console.log('ifxSuggestionSelected:', event);
          // Add your custom handler logic here
        });

            // Fired when the selected segment changes (previous and new value).
        document.querySelector('#ifx-segmented-control-example ifx-segmented-control')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Fired when this segment is selected (emits the segment index).
        document.querySelector('#ifx-segmented-control-example ifx-segmented-control')?.addEventListener('segmentSelect', (event) => {
          console.log('segmentSelect:', event);
          // Add your custom handler logic here
        });

            // Fired when the input / search value changes.
        document.querySelector('#ifx-select-example ifx-select')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

        // Fired when an option is selected.
        document.querySelector('#ifx-select-example ifx-select')?.addEventListener('ifxSelect', (event) => {
          console.log('ifxSelect:', event);
          // Add your custom handler logic here
        });

            // Fired when the active step changes.
        document.querySelector('#ifx-stepper-example ifx-stepper')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // Fired when the active step changes.
        document.querySelector('#ifx-stepper-example ifx-stepper')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // Emitted when checked state changes.
        document.querySelector('#ifx-switch-example ifx-switch')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

            // Emitted when sort order changes.
        document.querySelector('#ifx-table-example ifx-table')?.addEventListener('ifxSortChange', (event) => {
          console.log('ifxSortChange:', event);
          // Add your custom handler logic here
        });

            // Emitted when the active tab changes (e.g., user selects a different tab).
        document.querySelector('#ifx-tabs-example ifx-tabs')?.addEventListener('ifxChange', (event) => {
          console.log('ifxChange:', event);
          // Add your custom handler logic here
        });

        // Emitted when tab header triggers a change (selection or property updates).
        document.querySelector('#ifx-tabs-example ifx-tabs')?.addEventListener('tabHeaderChange', (event) => {
          console.log('tabHeaderChange:', event);
          // Add your custom handler logic here
        });

            // Fired when the user types or the value changes.
        document.querySelector('#ifx-text-field-example ifx-text-field')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });

            // Fired when the textarea value changes.
        document.querySelector('#ifx-textarea-example ifx-textarea')?.addEventListener('ifxInput', (event) => {
          console.log('ifxInput:', event);
          // Add your custom handler logic here
        });
      /* </AUTO-GENERATED-SCRIPTS> */
      
      // Manual Examples - Modal
      const modal = document.getElementById('modal');
      const openButton = document.getElementById('open-modal');
      
      openButton?.addEventListener('click', () => {
        if (modal) {
          modal.opened = true;
        }
      });
      
      modal?.addEventListener('ifxOpen', (event) => {
        console.log('ifxOpen:', event.detail);
      });
      
      modal?.addEventListener('ifxClose', (event) => {
        console.log('ifxClose:', event.detail);
      });
    